import { PortalProcessData } from '@nx-frontend/shared/types';

export const calcProcessData = ({
  items,
  status,
  sequential,
}: Pick<PortalProcessData, 'status' | 'items' | 'sequential'>): PortalProcessData => {
  const itemsCount = items.filter((item) => item.visible).length;
  const itemsProgress = items.filter((item) => item.visible && item.status === 'progress').length;
  const itemsDone = items.filter((item) => item.visible && item.status === 'done').length;

  const calcStatus =
    itemsDone > 0 && itemsDone >= itemsCount ? 'done' : itemsProgress > 0 || itemsDone > 0 ? 'progress' : status;

  return {
    status: calcStatus,
    itemsCount,
    itemsDone,
    items,
    sequential,
  };
};
